export default __webpack_public_path__ + "static/media/slide2.06142483.jpg";